import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import CancelIcon from '../icons/cancel'
import FlagIcon from '../icons/flag'
import OkIcon from '../icons/ok'
import AlertIcon from '../icons/alert'

const AlertBox = ({
  children,
  type = 'warning',
  onDismiss,
  showIcon = true
}) => {
  const mainClasses = classNames('fds-c-alert-box', 'fds-u-mt2', {
    '-type-success': type === 'success',
    '-type-alert': type === 'failure'
  })

  const onDismissWrapper = event => {
    event.preventDefault()
    onDismiss(event)
  }

  let icon
  switch (type) {
    case 'warning':
      icon = <FlagIcon />
      break
    case 'success':
      icon = <OkIcon />
      break
    case 'failure':
      icon = <AlertIcon />
      break
    default:
      icon = null
  }

  return (
    <div className={mainClasses}>
      {showIcon ? <div className="fds-c-alert-box__icon">{icon}</div> : null}
      <div className="fds-c-alert-box__message">
        <p className="fds-c-text-body -size-s fds-u-m0">{children}</p>
      </div>
      {onDismiss ? <AlertBox.DismissButton onClick={onDismissWrapper} /> : null}
    </div>
  )
}

AlertBox.propTypes = {
  type: PropTypes.oneOf(['warning', 'success', 'failure']),
  onDismiss: PropTypes.func
}

AlertBox.DismissButton = ({ onClick }) => {
  return (
    <div className="fds-c-alert-box__dismiss">
      <a onClick={onClick} className="fds-c-alert-box__dismiss-icon">
        <CancelIcon />
      </a>
    </div>
  )
}

AlertBox.DismissButton.propTypes = {
  onClick: PropTypes.func
}

export default AlertBox



// WEBPACK FOOTER //
// ./client/components/alerts/alertBox.js